setPmSectionErrorAction